package dk.smark.chat

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import dk.smark.chat.auth.CredentialsStorage
import dk.smark.chat.auth.SavedCredentials
import dk.smark.chat.network.CreateUserRequest
import dk.smark.chat.network.ForgotPasswordRequest
import dk.smark.chat.network.LoginRequest
import dk.smark.chat.network.LoginResponse
import dk.smark.chat.network.UserApiService
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class MainViewModel(
    private val userApiService: UserApiService,
    private val credentialsStorage: CredentialsStorage) : ViewModel() {

    private val _currentUser = MutableStateFlow<LoginResponse?>(null)
    val currentUser: StateFlow<LoginResponse?> = _currentUser

    fun login(email: String, password: String, rememberMe: Boolean, onSuccess: () -> Unit, onError: (String) -> Unit) {
        println("LOGIN: launch starting")
        viewModelScope.launch {
            try {
                val response = userApiService.login(LoginRequest(email, password))
                if (response.email != null) {
                    if (response.confirmed == false) {
                        onError("Please confirm your email address before logging in. Check your inbox for a confirmation link.")
                    } else {
                        _currentUser.value = response
                        if (rememberMe) {
                            credentialsStorage.save(email, password)
                        } else {
                            credentialsStorage.clear()
                        }
                        onSuccess()
                    }
                } else {
                    onError("Invalid credentials")
                }
            } catch (e: Exception) {
                onError(e.message ?: "Login failed")
            }
        }
    }

    fun createUser(name: String, email: String, password: String, onSuccess: () -> Unit, onError: (String) -> Unit) {
        viewModelScope.launch {
            try {
                userApiService.createUser(CreateUserRequest(email, name, password))
                onSuccess()
            } catch (e: Exception) {
                onError(e.message ?: "Registration failed")
            }
        }
    }

    fun deleteUser(onSuccess: () -> Unit, onError: (String) -> Unit) {
        val id = _currentUser.value?.id ?: return onError("No user logged in")
        viewModelScope.launch {
            try {
                userApiService.deleteUser(id)
                _currentUser.value = null
                credentialsStorage.clear()
                onSuccess()
            } catch (e: Exception) {
                onError(e.message ?: "Failed to delete account")
            }
        }
    }

    fun forgotPassword(email: String, onSuccess: () -> Unit, onError: (String) -> Unit) {
        viewModelScope.launch {
            try {
                userApiService.forgotPassword(ForgotPasswordRequest(email))
                onSuccess()
            } catch (e: Exception) {
                onError(e.message ?: "Request failed")
            }
        }
    }

    fun getSavedCredentials(): SavedCredentials? = credentialsStorage.load()
    fun clearSavedCredentials() {
        _currentUser.value = null
        credentialsStorage.clear()
    }
}